import { Component, Inject, LOCALE_ID, OnInit, Renderer2 } from '@angular/core';
import { ConfigService } from '../@vex/services/config.service';
import { Settings } from 'luxon';
import { DOCUMENT } from '@angular/common';
import { Platform } from '@angular/cdk/platform';
import { NavigationService } from '../@vex/services/navigation.service';
import icLayers from '@iconify/icons-ic/twotone-layers';
import icAssigment from '@iconify/icons-ic/twotone-assignment';
import icContactSupport from '@iconify/icons-ic/twotone-contact-support';
import icDateRange from '@iconify/icons-ic/twotone-date-range';
import icChat from '@iconify/icons-ic/twotone-chat';
import icPerson from '@iconify/icons-ic/person';
import icGroup from '@iconify/icons-ic/group'
import icContacts from '@iconify/icons-ic/twotone-contacts';
import icAssessment from '@iconify/icons-ic/twotone-assessment';
import icLock from '@iconify/icons-ic/twotone-lock';
import icWatchLater from '@iconify/icons-ic/twotone-watch-later';
import icError from '@iconify/icons-ic/twotone-error';
import icAttachMoney from '@iconify/icons-ic/twotone-attach-money';
import icPersonOutline from '@iconify/icons-ic/twotone-person-outline';
import icReceipt from '@iconify/icons-ic/twotone-receipt';
import icHelp from '@iconify/icons-ic/twotone-help';
import icBook from '@iconify/icons-ic/twotone-book';
import icBubbleChart from '@iconify/icons-ic/twotone-bubble-chart';
import icFormatColorText from '@iconify/icons-ic/twotone-format-color-text';
import icStar from '@iconify/icons-ic/twotone-star';
import icViewCompact from '@iconify/icons-ic/twotone-view-compact';
import icPictureInPicture from '@iconify/icons-ic/twotone-picture-in-picture';
import icSettings from '@iconify/icons-ic/twotone-settings';
import { LayoutService } from '../@vex/services/layout.service';
import icUpdate from '@iconify/icons-ic/twotone-update';
import { ActivatedRoute } from '@angular/router';
import { filter, map } from 'rxjs/operators';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { SplashScreenService } from '../@vex/services/splash-screen.service';
import { Style, StyleService } from '../@vex/services/style.service';
import icChromeReaderMode from '@iconify/icons-ic/twotone-chrome-reader-mode';
import { ConfigName } from '../@vex/interfaces/config-name.model';
import icMail from '@iconify/icons-ic/twotone-mail';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'vex-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit{
  title = 'ID-Telemetria';

  constructor(private configService: ConfigService,
              private styleService: StyleService,
              private renderer: Renderer2,
              private platform: Platform,
              @Inject(DOCUMENT) private document: Document,
              @Inject(LOCALE_ID) private localeId: string,
              private layoutService: LayoutService,
              private route: ActivatedRoute,
              private navigationService: NavigationService,
              private splashScreenService: SplashScreenService) {
    Settings.defaultLocale = this.localeId;

    if (this.platform.BLINK) {
      this.renderer.addClass(this.document.body, 'is-blink');
    }

    /**
     * Customize the template to your needs with the ConfigService
     * Example:
     *  this.configService.updateConfig({
     *    sidenav: {
     *      title: 'Custom App',
     *      imageUrl: '//placehold.it/100x100',
     *      showCollapsePin: false
     *    },
     *    footer: {
     *      visible: false
     *    }
     *  });
     */

    /**
     * Config Related Subscriptions
     * You can remove this if you don't need the functionality of being able to enable specific configs with queryParams
     * Example: example.com/?layout=apollo&style=default
     */
    this.route.queryParamMap.pipe(
      filter(queryParamMap => queryParamMap.has('rtl')),
      map(queryParamMap => coerceBooleanProperty(queryParamMap.get('rtl'))),
    ).subscribe(isRtl => {
      this.configService.updateConfig({
        rtl: isRtl
      });
    });

    this.route.queryParamMap.pipe(
      filter(queryParamMap => queryParamMap.has('layout'))
    ).subscribe(queryParamMap => this.configService.setConfig(queryParamMap.get('layout') as ConfigName));

    this.route.queryParamMap.pipe(
      filter(queryParamMap => queryParamMap.has('style'))
    ).subscribe(queryParamMap => this.styleService.setStyle(queryParamMap.get('style') as Style));


    /**
     * Add your own routes here
     */
    this.navigationService.items = [
      {
        type: 'link',
        label: 'Dashboard',
        route: '/',
        icon: icLayers,
        permission: 'Header.Menu.Dashboard',
        routerLinkActiveOptions: { exact: true }
      },
      // {
      //   type: 'subheading',
      //   label: 'Apps',
      //   children: [
      //     {
      //       type: 'link',
      //       label: 'All-In-One Table',
      //       route: '/apps/aio-table',
      //       icon: icAssigment
      //     },
      //     {
      //       type: 'dropdown',
      //       label: 'Help Center',
      //       icon: icContactSupport,
      //       children: [
      //         {
      //           type: 'link',
      //           label: 'Getting Started',
      //           route: '/apps/help-center/getting-started'
      //         },
      //         {
      //           type: 'link',
      //           label: 'Pricing & Plans',
      //           route: '/apps/help-center/pricing'
      //         },
      //         {
      //           type: 'link',
      //           label: 'FAQ',
      //           route: '/apps/help-center/faq'
      //         },
      //         {
      //           type: 'link',
      //           label: 'Guides',
      //           route: '/apps/help-center/guides'
      //         }
      //       ]
      //     },
      //     {
      //       type: 'link',
      //       label: 'Calendar',
      //       route: '/apps/calendar',
      //       icon: icDateRange,
      //       badge: {
      //         value: '12',
      //         bgClass: 'bg-deep-purple',
      //         textClass: 'text-deep-purple-contrast',
      //       },
      //     },
      //     {
      //       type: 'link',
      //       label: 'Chat',
      //       route: '/apps/chat',
      //       icon: icChat,
      //       badge: {
      //         value: '16',
      //         bgClass: 'bg-cyan',
      //         textClass: 'text-cyan-contrast',
      //       },
      //     },
      //     {
      //       type: 'link',
      //       label: 'Mailbox',
      //       route: '/apps/mail',
      //       icon: icMail,
      //     },
      //     {
      //       type: 'dropdown',
      //       label: 'Social',
      //       icon: icPersonOutline,
      //       children: [
      //         {
      //           type: 'link',
      //           label: 'Profile',
      //           route: '/apps/social',
      //           routerLinkActiveOptions: { exact: true }
      //         },
      //         {
      //           type: 'link',
      //           label: 'Timeline',
      //           route: '/apps/social/timeline'
      //         },
      //       ]
      //     },
      //     {
      //       type: 'link',
      //       label: 'WYSIWYG Editor',
      //       route: '/apps/editor',
      //       icon: icChromeReaderMode
      //     },
      //     {
      //       type: 'dropdown',
      //       label: 'Contacts',
      //       icon: icContacts,
      //       children: [
      //         {
      //           type: 'link',
      //           label: 'List - Grid',
      //           route: '/apps/contacts/grid',
      //         },
      //         {
      //           type: 'link',
      //           label: 'List - Table',
      //           route: '/apps/contacts/table',
      //         }
      //       ]
      //     },
      //     {
      //       type: 'link',
      //       label: 'Scrumboard',
      //       route: '/apps/scrumboard',
      //       icon: icAssessment,
      //       badge: {
      //         value: 'NEW',
      //         bgClass: 'bg-primary',
      //         textClass: 'text-primary-contrast',
      //       }
      //     },
      //   ]
      // },
      // {
      //   type: 'subheading',
      //   label: 'Pages',
      //   children: [
      //     {
      //       type: 'dropdown',
      //       label: 'Authentication',
      //       icon: icLock,
      //       children: [
      //         {
      //           type: 'link',
      //           label: 'Login',
      //           route: '/login'
      //         },
      //         {
      //           type: 'link',
      //           label: 'Register',
      //           route: '/register'
      //         },
      //         {
      //           type: 'link',
      //           label: 'Forgot Password',
      //           route: '/forgot-password'
      //         }
      //       ]
      //     },
      //     {
      //       type: 'link',
      //       label: 'Coming Soon',
      //       icon: icWatchLater,
      //       route: '/coming-soon'
      //     },
      //     {
      //       type: 'dropdown',
      //       label: 'Errors',
      //       icon: icError,
      //       badge: {
      //         value: '4',
      //         bgClass: 'bg-green',
      //         textClass: 'text-green-contrast',
      //       },
      //       children: [
      //         {
      //           type: 'link',
      //           label: '404',
      //           route: '/pages/error-404'
      //         },
      //         {
      //           type: 'link',
      //           label: '500',
      //           route: '/pages/error-500'
      //         }
      //       ]
      //     },
      //     {
      //       type: 'link',
      //       label: 'Pricing',
      //       icon: icAttachMoney,
      //       route: '/pages/pricing'
      //     },
      //     {
      //       type: 'link',
      //       label: 'Invoice',
      //       icon: icReceipt,
      //       route: '/pages/invoice'
      //     },
      //     {
      //       type: 'link',
      //       label: 'FAQ',
      //       icon: icHelp,
      //       route: '/pages/faq'
      //     },
      //     {
      //       type: 'link',
      //       label: 'Guides',
      //       icon: icBook,
      //       route: '/pages/guides',
      //       badge: {
      //         value: '18',
      //         bgClass: 'bg-teal',
      //         textClass: 'text-teal-contrast',
      //       },
      //     },
      //   ]
      // },
      // {
      //   type: 'subheading',
      //   label: 'UI Elements',
      //   children: [
      //     {
      //       type: 'dropdown',
      //       label: 'Components',
      //       icon: icBubbleChart,
      //       children: [
      //         {
      //           type: 'link',
      //           label: 'Overview',
      //           route: '/ui/components/overview'
      //         },
      //         {
      //           type: 'link',
      //           label: 'Autocomplete',
      //           route: '/ui/components/autocomplete'
      //         },
      //         {
      //           type: 'link',
      //           label: 'Buttons',
      //           route: '/ui/components/buttons'
      //         },
      //         {
      //           type: 'link',
      //           label: 'Button Group',
      //           route: '/ui/components/button-group'
      //         },
      //         {
      //           type: 'link',
      //           label: 'Cards',
      //           route: '/ui/components/cards'
      //         },
      //         {
      //           type: 'link',
      //           label: 'Checkbox',
      //           route: '/ui/components/checkbox'
      //         },
      //         {
      //           type: 'link',
      //           label: 'Dialogs',
      //           route: '/ui/components/dialogs'
      //         },
      //         {
      //           type: 'link',
      //           label: 'Grid List',
      //           route: '/ui/components/grid-list'
      //         },
      //         {
      //           type: 'link',
      //           label: 'Input',
      //           route: '/ui/components/input'
      //         },
      //         {
      //           type: 'link',
      //           label: 'Lists',
      //           route: '/ui/components/lists'
      //         },
      //         {
      //           type: 'link',
      //           label: 'Menu',
      //           route: '/ui/components/menu'
      //         },
      //         {
      //           type: 'link',
      //           label: 'Progress',
      //           route: '/ui/components/progress'
      //         },
      //         {
      //           type: 'link',
      //           label: 'Progress Spinner',
      //           route: '/ui/components/progress-spinner'
      //         },
      //         {
      //           type: 'link',
      //           label: 'Radio',
      //           route: '/ui/components/radio'
      //         },
      //         {
      //           type: 'link',
      //           label: 'Slide Toggle',
      //           route: '/ui/components/slide-toggle'
      //         },
      //         {
      //           type: 'link',
      //           label: 'Slider',
      //           route: '/ui/components/slider'
      //         },
      //         {
      //           type: 'link',
      //           label: 'Snack Bar',
      //           route: '/ui/components/snack-bar'
      //         },
      //         {
      //           type: 'link',
      //           label: 'Tooltip',
      //           route: '/ui/components/tooltip'
      //         },
      //       ]
      //     },
      //     {
      //       type: 'dropdown',
      //       label: 'Forms',
      //       icon: icFormatColorText,
      //       children: [
      //         {
      //           type: 'link',
      //           label: 'Form Elements',
      //           route: '/ui/forms/form-elements'
      //         },
      //         {
      //           type: 'link',
      //           label: 'Form Wizard',
      //           route: '/ui/forms/form-wizard'
      //         }
      //       ]
      //     },
      //     {
      //       type: 'dropdown',
      //       label: 'Icons',
      //       icon: icStar,
      //       children: [
      //         {
      //           type: 'link',
      //           label: 'Material Icons',
      //           route: '/ui/icons/ic'
      //         },
      //         {
      //           type: 'link',
      //           label: 'FontAwesome Icons',
      //           route: '/ui/icons/fa'
      //         }
      //       ]
      //     },
      //     {
      //       type: 'dropdown',
      //       label: 'Page Layouts',
      //       icon: icViewCompact,
      //       children: [
      //         {
      //           type: 'dropdown',
      //           label: 'Card',
      //           children: [
      //             {
      //               type: 'link',
      //               label: 'Default',
      //               route: '/ui/page-layouts/card',
      //               routerLinkActiveOptions: { exact: true }
      //             },
      //             {
      //               type: 'link',
      //               label: 'Tabbed',
      //               route: '/ui/page-layouts/card/tabbed',
      //             },
      //             {
      //               type: 'link',
      //               label: 'Large Header',
      //               route: '/ui/page-layouts/card/large-header',
      //               routerLinkActiveOptions: { exact: true }
      //             },
      //             {
      //               type: 'link',
      //               label: 'Tabbed & Large Header',
      //               route: '/ui/page-layouts/card/large-header/tabbed'
      //             }
      //           ]
      //         },
      //         {
      //           type: 'dropdown',
      //           label: 'Simple',
      //           children: [
      //             {
      //               type: 'link',
      //               label: 'Default',
      //               route: '/ui/page-layouts/simple',
      //               routerLinkActiveOptions: { exact: true }
      //             },
      //             {
      //               type: 'link',
      //               label: 'Tabbed',
      //               route: '/ui/page-layouts/simple/tabbed',
      //             },
      //             {
      //               type: 'link',
      //               label: 'Large Header',
      //               route: '/ui/page-layouts/simple/large-header',
      //               routerLinkActiveOptions: { exact: true }
      //             },
      //             {
      //               type: 'link',
      //               label: 'Tabbed & Large Header',
      //               route: '/ui/page-layouts/simple/large-header/tabbed'
      //             }
      //           ]
      //         },
      //         {
      //           type: 'link',
      //           label: 'Blank',
      //           icon: icPictureInPicture,
      //           route: '/ui/page-layouts/blank'
      //         },
      //       ]
      //     },
      //   ]
      // },
      // {
      //   type: 'subheading',
      //   label: 'Documentation',
      //   children: [
      //     {
      //       type: 'link',
      //       label: 'Changelog',
      //       route: '/documentation/changelog',
      //       icon: icUpdate
      //     },
      //     {
      //       type: 'dropdown',
      //       label: 'Getting Started',
      //       icon: icBook,
      //       children: [
      //         {
      //           type: 'link',
      //           label: 'Introduction',
      //           route: '/documentation/introduction',
      //           fragment: 'introduction',
      //           routerLinkActiveOptions: { exact: true }
      //         },
      //         {
      //           type: 'link',
      //           label: 'Folder Structure',
      //           route: '/documentation/folder-structure',
      //           fragment: 'folder-structure',
      //           routerLinkActiveOptions: { exact: true }
      //         },
      //         {
      //           type: 'link',
      //           label: 'Installation',
      //           route: '/documentation/installation',
      //           fragment: 'installation',
      //           routerLinkActiveOptions: { exact: true }
      //         },
      //         {
      //           type: 'link',
      //           label: 'Development Server',
      //           route: '/documentation/start-development-server',
      //           fragment: 'start-development-server',
      //           routerLinkActiveOptions: { exact: true }
      //         },
      //         {
      //           type: 'link',
      //           label: 'Build for Production',
      //           route: '/documentation/build-for-production',
      //           fragment: 'build-for-production',
      //           routerLinkActiveOptions: { exact: true }
      //         }
      //       ]
      //     },
      //     {
      //       type: 'dropdown',
      //       label: 'Customization',
      //       icon: icBook,
      //       children: [
      //         {
      //           type: 'link',
      //           label: 'Configuration',
      //           route: '/documentation/configuration',
      //           fragment: 'configuration',
      //           routerLinkActiveOptions: { exact: true }
      //         },
      //         {
      //           type: 'link',
      //           label: 'Changing Styling',
      //           route: '/documentation/changing-styling-and-css-variables',
      //           fragment: 'changing-styling-and-css-variables',
      //           routerLinkActiveOptions: { exact: true }
      //         },
      //         {
      //           type: 'link',
      //           label: 'Using Custom Colors',
      //           route: '/documentation/using-custom-colors-for-the-primarysecondarywarn-palettes',
      //           fragment: 'using-custom-colors-for-the-primarysecondarywarn-palettes',
      //           routerLinkActiveOptions: { exact: true }
      //         },
      //         {
      //           type: 'link',
      //           label: 'Adding Menu Items',
      //           route: '/documentation/adding-menu-items',
      //           fragment: 'adding-menu-items',
      //           routerLinkActiveOptions: { exact: true }
      //         },
      //       ]
      //     },
      //     {
      //       type: 'link',
      //       label: 'Further Help',
      //       icon: icBook,
      //       route: '/documentation/further-help',
      //       fragment: 'further-help',
      //       routerLinkActiveOptions: { exact: true }
      //     },
      //   ]
      // },
      {
        type: 'subheading',
        label: 'Ordens Serviços',
        permission: 'Header.Menu.OrdensServico',
        children: [
          {
            type: 'link',
            label: 'Execução de Processos',
            icon: icAssigment,
            route: '/process/execute',
            permission: 'Header.Menu.OrdensServico.ExecucaoProcessos',
          },
          {
            type: 'link',
            label: 'Consultar Processos',
            icon: icAssigment,
            route: '/process/consult',
            permission: 'Header.Menu.OrdensServico.ConsultarProcessos'
          },
          {
            type: 'link',
            label: 'Requisição de Processos',
            icon: icAssigment,
            route: '/process/request',
            permission: 'Header.Menu.OrdensServico.RequisicaoProcessos'
          },
          {
            type: 'link',
            label: 'Medição de Processos',
            icon: icAssigment,
            route: '/measurement',
            permission: 'Header.Menu.OrdensServico.MedicaoProcessos',
          },
          {
            type: 'link',
            label: 'Processos Retroativos',
            icon: icAssigment,
            route: '/process-retroactive',
            permission: 'Header.Menu.OrdensServico.ProcessosRetroativos',
          }
        ]
      },
      {
        type: 'subheading',
        label: 'Serviços Manutenção',
        permission: 'Header.Menu.OrdensServicoManutencao',
        children: [
          {
            type: 'link',
            label: 'Execução de Processos',
            icon: icAssigment,
            route: '/processOSM/execute',
            permission: 'Header.Menu.OrdensServicoManutencao.ExecucaoProcessos',
          },
          {
            type: 'link',
            label: 'Consultar Processos',
            icon: icAssigment,
            route: '/processOSM/consult',
            permission: 'Header.Menu.OrdensServicoManutencao.ConsultarProcessos'
          },
        ]
      },
      {
        type: 'subheading',
        label: 'Cadastros & Consultas',
        permission: 'Header.Menu.CadastrosConsultas',
        children: [
          {
            type: 'link',
            label: 'Frotas',
            icon: icAssigment,
            route: '/asset',
            permission: 'Header.Menu.CadastrosConsultas.Assets'
          },   
          {
            type: 'link',
            label: 'Operadores',
            icon: icAssigment,
            route: '/operator-control/operator',
            permission: 'Header.Menu.CadastrosConsultas.Operators',
          },   
          {
            type: 'link',            
            label: 'Rateio',
            icon: icAssigment,
            route: '/cost-rate',
            permission: 'Header.Menu.CadastrosConsultas.CostRate',
          },       
          {
            type: 'link',            
            label: 'Ociosidade',
            icon: icAssigment,
            route: '/idleness',
            permission: 'Header.Menu.CadastrosConsultas.Ociosidade',
          },
          {
            type: 'link',
            label: 'Disponibilidade',
            icon: icAssigment,
            route: '/availability',
            permission: 'Header.Menu.CadastrosConsultas.Disponibilidade',
          },
          {
            type: 'link',
            label: 'Utilização',
            icon: icAssigment,
            route: '/usage',
            permission: 'Header.Menu.CadastrosConsultas.Utilizacao',
          },
          {
            type: 'link',
            label: 'Movimentações',
            icon: icAssigment,
            route: '/movement',
            permission: 'Header.Menu.CadastrosConsultas.Movimentacao',
          },
        ]
      },
      {
        type: 'subheading',
        label: 'Parâmetros',
        permission: 'Header.Menu.Parametros',
        children: [
          {
            type: 'dropdown',
            label: 'Parâmetros Corporativos',
            icon: icBook,
            permission: 'Header.Menu.Parametros.ParametrosCorporativos',
            children: [
              {
                type: 'link',
                label: 'Segmentos',
                route: '/business-line',
                permission: 'Header.Menu.Parametros.ParametrosCorporativos.BusinessLine',
                routerLinkActiveOptions: { exact: true }
              },
              {
                type: 'link',
                label: 'Divisões',
                route: '/division',
                permission: 'Header.Menu.Parametros.ParametrosCorporativos.Division',
                routerLinkActiveOptions: { exact: true }
              },              
              {
                type: 'link',
                label: 'Almoxarifados',
                icon: icAssigment,
                route: '/warehouse',
                permission: 'Header.Menu.Parametros.ParametrosCorporativos.Warehouse',
              },
              {
                type: 'link',
                label: 'Geolocalizações',
                icon: icAssigment,
                route: '/geolocation',
                permission: 'Header.Menu.Parametros.ParametrosCorporativos.Geolocation',
              },
              {
                type: 'link',
                label: 'Treinamentos',
                icon: icAssigment,
                route: '/training',
                permission: 'Header.Menu.Parametros.ParametrosCorporativos.Training',
              }
            ]
          },
          {
            type: 'dropdown',
            label: 'Parâmetros Equipamentos',
            permission: 'Header.Menu.Parametros.ParametrosEquipamentos',
            icon: icBook,
            children: [
              {
                type: 'link',
                label: 'Tipos de Frota',
                route: '/asset-type',
                routerLinkActiveOptions: { exact: true },
                permission: 'Header.Menu.Parametros.ParametrosEquipamentos.AssetType',
              },
              {
                type: 'link',
                label: 'Dispositivos',
                icon: icAssigment,
                route: '/device',
                permission: 'Header.Menu.Parametros.ParametrosEquipamentos.Devices',
              },
              {
                type: 'link',
                label: 'Manutenções',
                icon: icAssigment,
                route: '/maintenance',
                permission: 'Header.Menu.Parametros.ParametrosEquipamentos.Maintenances',
              },
              {
                type: 'link',
                label: 'Câmeras',
                icon: icAssigment,
                route: '/cameras/cameras-parameters',
                permission: 'Header.Menu.Parametros.ParametrosEquipamentos.Devices',
              },

            ]
          },
          {
            type: 'dropdown',
            label: 'Parâmetros E-mails',
            icon: icBook,
            permission: 'Header.Menu.Parametros.ParametrosCorporativos',
            children: [
              {
                type: 'link',
                label: 'Categorias',
                route: '/email-categories',
                permission: 'Header.Menu.Parametros.ParametrosCorporativos.BusinessLine',
                routerLinkActiveOptions: { exact: true }
              }
            ]
          },
        ]
      },
      {
        type: 'subheading',
        label: 'Administração',
        permission: 'Header.Menu.Administracao',
        children: [
          {
            type: 'link',
            label: 'Usuários',
            icon: icPerson,
            route: '/user',
            permission: 'Header.Menu.Administracao.Usuarios',
          },
          {
            type: 'link',
            label: 'Funções',
            icon: icGroup,
            route: '/role',
            permission: 'Header.Menu.Administracao.Funcoes',
          },
        ]
      },
      // {
      //   type: 'link',
      //   label: 'Configuration',
      //   route: () => this.layoutService.openConfigpanel(),
      //   icon: icSettings
      // }
    ];
  }
  ngOnInit() {
    if (environment.production && location.protocol === 'http:') {
      window.location.href = location.href.replace('http', 'https');
    }
  }
}
